/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEscalationTicketRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {UpdateEscalationTicketResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const updateEscalationTicket = (request: UpdateEscalationTicketRequest, options?: CashRequestOptions) => post<UpdateEscalationTicketRequest, UpdateEscalationTicketResponse>("/2.0/cash/update-escalation-ticket", request, {...options, rejectOnError: true })